import { Navigate } from "react-router-dom";

function PrivateRoutes({ children }) {
  const token = localStorage.getItem("admintoken");
  
  return token ? children : <Navigate to="/login" />;
}

export default PrivateRoutes;